export default __webpack_public_path__ + "static/media/mlai.5dd47cd6.jpg";